export function ruleJoin(value: string | string[], relation: string = '或') {
  if (typeof value === 'string') {
    value = value.split(',');
  }
  return value.map((value) => `'${value}'`).join(relation);
}
